import {
  EmployeeSalaryAdjustmentsDetail,
  EmployeeSalaryAdjustmentsDetailRequest,
  EmployeeSalaryAdjustmentsInfoItem,
  EmployeeSalaryAdjustmentsItem,
} from 'bus/employeeSalaryAdjustments/types';

import { PayloadRequest } from 'types/requestTypes';

import $axios from '../utils/axios-instance';

export default class EmployeeSalaryAdjustmentsApi {
  async getEmployeeSalaryAdjustments(data: PayloadRequest) {
    return await $axios
      .get<EmployeeSalaryAdjustmentsItem>(`/v1/employeeSalaryAdjustments/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createEmployeeSalaryAdjustments(data: EmployeeSalaryAdjustmentsItem) {
    return await $axios
      .post('/v1/employeeSalaryAdjustments/', data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async editEmployeeSalaryAdjustments(data: EmployeeSalaryAdjustmentsItem) {
    return await $axios
      .put(`/v1/employeeSalaryAdjustments/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteEmployeeSalaryAdjustments(data: PayloadRequest) {
    return await $axios
      .delete(`/v1/employeeSalaryAdjustments/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getEmployeeSalaryAdjustmentsInfo(data: PayloadRequest) {
    return await $axios
      .get<EmployeeSalaryAdjustmentsInfoItem>(`/v1/employeeSalaryAdjustments/${data.id}/info`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  //detail
  async getEmployeeSalaryAdjustmentsDetailList(data: PayloadRequest) {
    return await $axios
      .get<EmployeeSalaryAdjustmentsDetail[]>(`/v1/employeeSalaryAdjustments/${data.id}/details`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async getEmployeeSalaryAdjustmentsDetailOne(data: PayloadRequest) {
    return await $axios
      .get<EmployeeSalaryAdjustmentsDetail>(`/v1/employeeSalaryAdjustments/details/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async createEmployeeSalaryAdjustmentsDetail(data: EmployeeSalaryAdjustmentsDetailRequest) {
    return await $axios
      .post(`/v1/employeeSalaryAdjustments/${data.adjustmentId}/details`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async editEmployeeSalaryAdjustmentsDetail(data: EmployeeSalaryAdjustmentsDetailRequest) {
    return await $axios
      .put(`/v1/employeeSalaryAdjustments/details/${data.id}`, data)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }

  async deleteEmployeeSalaryAdjustmentsDetail(data: PayloadRequest) {
    return await $axios
      .delete(`/v1/employeeSalaryAdjustments/details/${data.id}`)
      .then((res) => res)
      .catch((e) => {
        throw e;
      });
  }
}
